// extracted by mini-css-extract-plugin
export default {"header":"header___gztdW","headerLeft":"headerLeft___Ku6I5"};